/**
 * Hero Section Component
 * Displays the main hero section with CTA text, subtitle, action buttons, carousel placeholder and image
 */

export interface HeroConfig {
  ctaText: string
  subtitle: string
  heroImage: string
  uploadButtonText: string
  paymentButtonText: string
  onUploadClick: () => void
  onPaymentClick: () => void
}

export class Hero {
  private config: HeroConfig
  public element: HTMLElement

  constructor(config: HeroConfig) {
    this.config = config
    this.element = this.render()
  }

  /**
   * Render the hero section
   */
  render(): HTMLElement {
    const section = document.createElement('section')
    section.id = 'hero'
    section.className = 'hero-section'

    section.innerHTML = `
      <div class="hero-content">
        <!-- Left side - Text content and Action Buttons -->
        <div class="hero-left-container">
          <h1 class="hero-cta" data-i18n="hero.title">
            ${this.config.ctaText}
          </h1>
          <p class="hero-subtitle" data-i18n="hero.subtitle">
            ${this.config.subtitle}
          </p>
          
          <!-- Action Buttons -->
          <div class="hero-actions">
            <button class="btn btn-primary btn-upload" data-i18n="hero.uploadDocs">
              ${this.config.uploadButtonText}
            </button>
            <button class="btn btn-secondary btn-payment" data-i18n="hero.paymentCenter">
              ${this.config.paymentButtonText}
            </button>
          </div>
        </div>

        <!-- Right side - Image only -->
        <div class="hero-right-container">
          <div class="hero-image-container">
            <img src="${this.config.heroImage}" alt="BeSafe Property" class="hero-image" loading="eager">
          </div>
        </div>
      </div>
    `

    // Attach event listeners
    this.attachEventListeners(section)

    return section
  }

  /**
   * Attach event listeners to buttons
   */
  private attachEventListeners(section: HTMLElement): void {
    const uploadBtn = section.querySelector('.btn-upload')
    const paymentBtn = section.querySelector('.btn-payment')

    if (uploadBtn) {
      uploadBtn.addEventListener('click', () => {
        this.config.onUploadClick()
      })
    }

    if (paymentBtn) {
      paymentBtn.addEventListener('click', () => {
        this.config.onPaymentClick()
      })
    }

    
  }
}
